import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { captchaTokenSelector, captchaStatusSelector, captchaWhitelistSelector } from '../ducks/selectors.js';
import { grecaptchaExecute, loadCaptcha, resetCaptcha, whiteListCaptcha } from '../ducks/actions.js';
// shouldLoadCaptcha - only load captcha script when necessary.
const useCaptcha = (shouldLoadCaptcha = false) => {
	const captchaToken = useSelector(captchaTokenSelector);
	const captchaWhitelisted = useSelector(captchaWhitelistSelector);
	const captchaStatus = useSelector(captchaStatusSelector);
	const dispatch = useDispatch();

	// load captcha script on mount
	useEffect(() => {
		if (!shouldLoadCaptcha) {
			return;
		}
		dispatch(loadCaptcha());
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// either execute captcha or whitelist
	const resolveCaptcha = ({ triggerCaptcha = false }) => {
		if (triggerCaptcha) {
			dispatch(grecaptchaExecute());
		} else {
			dispatch(whiteListCaptcha());
		}
	};

	const resetCaptchaToken = () => {
		dispatch(resetCaptcha());
	};

	return {
		captchaToken,
		captchaWhitelisted,
		captchaStatus,
		resolveCaptcha,
		resetCaptchaToken
	};
};

export default useCaptcha;
